import { render } from "./SystemSort.vue?vue&type=template&id=23b3d802&scoped=true"
import script from "./SystemSort.vue?vue&type=script&lang=js"
export * from "./SystemSort.vue?vue&type=script&lang=js"

import "./SystemSort.vue?vue&type=style&index=0&id=23b3d802&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b3d802"]])

export default __exports__